import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/others/Card.css";
import "../css/others/Table.css";
import Card from "../Reusablecomponents/Card";
import BackButton from "../Reusablecomponents/BackButton";
import { apiCall } from "../main/ApiCall";
import IconComponent from "../Reusablecomponents/IconComponent";
import { ProjectDetail } from '../interFaces/interfaces';
const ProjectDetails: React.FC = () => {
  const [project, setProject] = useState<ProjectDetail | null>(null);
  const { projectId } = useParams<{ projectId: string }>();
  const clientId = localStorage.getItem("clientId");
  const navigate = useNavigate();
  useEffect(() => {
    if (!projectId) return;
    apiCall("get", `/api/projects?projectId=${projectId}&clientId=${clientId}`)
      .then((response) => setProject(response))
      .catch((error) => {
        console.error("Error fetching project details:", error);
      });
  }, [projectId, clientId]);
  const handleProjectHistoryClick = () => {
    if (projectId) navigate(`/project-history/${projectId}`)
  };
  const includedFields = ["projectId", "accountId", "accountName", "businessUnit", "projectName", "projectManagerName", "deliveryManagerName", "deliveryHeadName", "teamSize", "deliveryModel", "billingType", "qualityConsultantName", "qualityManagerName", "estimationModel", "devOps_CICDtoolname", "testingToolName", "codequalityToolName", "testManagerName", "architect", "technicalLeadName", "customerLocation", "projectLocation", "projectLifeCycle", "createdBy", "createdDate", "risk", "targetML", "updatedBy", "updatedDate", "projectStartDate", "projectEndDate", "projectCreatedBy", "projectCreatedDate", "projectUpdatedBy", "projectUpdatedDate", "projectManagerEmail", "deliveryManagerEmail", "deliveryHeadEmail", "qualityConsultantEmail", "qualityManagerEmail", "testManagerEmail", "technicalLeadEmail", "projectCategory", "status", "actualML"];
  return (
    <div className="container">
      <h1 className="title">Project Details</h1>
      {!project || Object.keys(project).length === 0 ? (
        <p className="spinner">Loading project details...</p>
      ) : (
        <>
          {project?.isHistoryAvailable && (
            <button className="history" onClick={handleProjectHistoryClick}>Project History</button>
          )}
          <div className="grid">
            {Object.entries(project).map(([key, value]) => {
              if (!includedFields.includes(key)) return null;
              const label = key
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, (str) => str.toUpperCase())
                .replace("Dev Ops CICDtoolname", "DevOps/CICD Tool")
                .replace("Codequality Tool Name", "Code Quality Tool");
              const displayValue = value === null || value === undefined || value === "" ? "N/A" : value;
              return (
                <Card key={key} label={label} value={displayValue} icon={<IconComponent name={key} className="icon" />} />
              );
            })}
          </div>
        </>
      )}
      <div className="buttons">
        <BackButton className="back-button2" label="Back" />
      </div>
    </div>
  );
};
export default ProjectDetails;